module.exports = __webpack_public_path__ + "img/background_Image.901974c4.png";